/**
 * After a new deploy, the hashed chunks this page was pinned to are gone.
 * Reloads once to fetch the fresh bundle and uses a cooldown to prevent loops.
 */

const RELOAD_KEY = 'beacon:stale-chunk-reload-at';
const COOLDOWN_MS = 10_000;

export function isStaleChunkError(error: unknown): boolean {
  const message = error instanceof Error ? error.message : String(error ?? '');

  return /dynamically imported module|module script failed|ChunkLoadError|Failed to fetch/i.test(message);
}

/** Reloads to grab the new bundle and returns false if already reloaded within the cooldown. */
export function reloadForStaleChunk(): boolean {
  const last = Number(sessionStorage.getItem(RELOAD_KEY) ?? 0);

  if (Date.now() - last < COOLDOWN_MS) return false;

  sessionStorage.setItem(RELOAD_KEY, String(Date.now()));
  window.location.reload();
  return true;
}

export function installStaleChunkReload(): void {
  window.addEventListener('vite:preloadError', (event) => {
    if (reloadForStaleChunk()) event.preventDefault();
  });
}
